// Windsurf generated file
import { createContext } from 'react'
import { FeatureFlags, defaultFlags } from '../../api/feature-flags-api'

export interface FeatureFlagsContextType {
  flags: FeatureFlags
  loading: boolean
  // Local dev tools
  localOverrides: Map<string, boolean>
  toggleLocalOverride: (flagName: keyof FeatureFlags) => void
  toggleAllLocalOverrides: () => void
  clearLocalOverrides: () => void
  pollFlag: (flagName: keyof FeatureFlags) => Promise<void>
}

const defaultContext: FeatureFlagsContextType = {
  flags: defaultFlags,
  loading: true,
  localOverrides: new Map(),
  toggleLocalOverride: () => {},
  toggleAllLocalOverrides: () => {},
  clearLocalOverrides: () => {},
  pollFlag: async () => {},
}

export const FeatureFlagsContext =
  createContext<FeatureFlagsContextType>(defaultContext)
